import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toStringSafe(_this__u8e3s4) {
  var tmp;
  try {
    tmp = toString(_this__u8e3s4());
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Exception()) {
      var e = $p;
      tmp_0 = DefaultErrorMessageProducer_instance.f2g(e);
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
}
var DefaultErrorMessageProducerClass;
function DefaultErrorMessageProducer() {
  if (DefaultErrorMessageProducerClass === VOID) {
    class $ {
      f2g(e) {
        return 'Log message invocation failed: ' + e.toString();
      }
    }
    initMetadataForObject($, 'DefaultErrorMessageProducer');
    DefaultErrorMessageProducerClass = $;
  }
  return DefaultErrorMessageProducerClass;
}
var DefaultErrorMessageProducer_instance;
function DefaultErrorMessageProducer_getInstance() {
  return DefaultErrorMessageProducer_instance;
}
//region block: init
DefaultErrorMessageProducer_instance = new (DefaultErrorMessageProducer())();
//endregion
//region block: exports
export {
  toStringSafe as toStringSafe207d7m7lap1sq,
};
//endregion

//# sourceMappingURL=MessageInvoker.mjs.map
